<template>
<b-modal
  ref="addGridRows"
  hide-footer
  centered
  title="Add rows"
  size="lg"
  >
  <b-form @submit.prevent="save">
    <b-form-group
      label="Rows"
    >
      <b-form-textarea
        type="text"
        v-model.trim="rowsData"
        autocomplete="off"
        rows="3"
      />
    </b-form-group>
    <b-button
      :disabled="Boolean(!rowsData.length)"
      variant="success"
      type="submit"
      >
      Save
    </b-button>
  </b-form>
</b-modal>
</template>

<script>
// helpers
import eventBus from '@/helpers/event-bus'

export default {
data () {
  return {
    rowsData: ''
  }
},
methods: {
  save(){
    let exportData = []
    let rowsArray = this.rowsData.split("\n")
    rowsArray.forEach(elem => {
      let item = elem.split("\t")
      exportData.push(item)
    })
    this.$emit('addGridRows', exportData)
    this.rowsData = ''
    this.$refs.addGridRows.hide() 
  }
},
created () {
  eventBus.$on('addGridRows', () => {
    if (this.$refs.addGridRows) this.$refs.addGridRows.show()
  })
},
mounted () {
  if (this.$refs.addGridRows) {
    $(this.$refs.addGridRows['$el']).appendTo('body')
  }
},
beforeDestroy () {
  if (this.$refs.addGridRows) {
    $(this.$refs.addGridRows['$el']).remove()
  }
}
}
</script>
